
     import {useContext} from "react";
     import {ZibiContext} from "./Context";

      const UseZibi = (props) => {
         const {
       
        user_context,
        
        shopper_context,
        
        isLoggedIn_context,
        
        busyIndicator_context,
        
        language_context,
        
        languageMap_context,
        
        languageOptions_context,
        
        initialRoutePath_context,
        
        currentSite_context,
        
        chooseSiteRequired_context,
        
        checkInRequired_context,
        
        sitesList_context,
        
        productsById_context,
        
        productsByBarCode_context,
        
        productsCart_context,
        
        stats_mode_context,
        
        stats_context,
        
        cartViewTable_context,
        
        sensorStatuses_context,
        
        shopperProductsCart_context,
        
        cameras_context,
        
        categories_context,
        
        camerasOnVif_context,
        
        fields_context,
        
        sensors_context,
        
        clients_context,
        
        sitesByClientId_context,
        
        siteEdges_context,
        
        siteFields_context,
        
        siteCameras_context,
         
       } = useContext(ZibiContext);
       
       // eslint-disable-next-line default-case
        switch (props) {
        
       case 'user':
          return user_context;
        
       case 'shopper':
          return shopper_context;
        
       case 'isLoggedIn':
          return isLoggedIn_context;
        
       case 'busyIndicator':
          return busyIndicator_context;
        
       case 'language':
          return language_context;
        
       case 'languageMap':
          return languageMap_context;
        
       case 'languageOptions':
          return languageOptions_context;
        
       case 'initialRoutePath':
          return initialRoutePath_context;
        
       case 'currentSite':
          return currentSite_context;
        
       case 'chooseSiteRequired':
          return chooseSiteRequired_context;
        
       case 'checkInRequired':
          return checkInRequired_context;
        
       case 'sitesList':
          return sitesList_context;
        
       case 'productsById':
          return productsById_context;
        
       case 'productsByBarCode':
          return productsByBarCode_context;
        
       case 'productsCart':
          return productsCart_context;
        
       case 'stats_mode':
          return stats_mode_context;
        
       case 'stats':
          return stats_context;
        
       case 'cartViewTable':
          return cartViewTable_context;
        
       case 'sensorStatuses':
          return sensorStatuses_context;
        
       case 'shopperProductsCart':
          return shopperProductsCart_context;
        
       case 'cameras':
          return cameras_context;
        
       case 'categories':
          return categories_context;
        
       case 'camerasOnVif':
          return camerasOnVif_context;
        
       case 'fields':
          return fields_context;
        
       case 'sensors':
          return sensors_context;
        
       case 'clients':
          return clients_context;
        
       case 'sitesByClientId':
          return sitesByClientId_context;
        
       case 'siteEdges':
          return siteEdges_context;
        
       case 'siteFields':
          return siteFields_context;
        
       case 'siteCameras':
          return siteCameras_context;
        
        }
        };

export default UseZibi;
    